import { required } from '@vuelidate/validators'

import { ValidatorsUtil } from '@shared/utils/Validators'

export default {
  address: {
    required,
    location: ValidatorsUtil.isLocation,
  },
}
